export const AnswerType = {
  TEXT: "TEXT",
  LONG_TEXT: "LONG_TEXT",
  NUMBER: "NUMBER",
  DATE: "DATE",
  OPTIONS_CHOOSE_ONE: "OPTIONS_CHOOSE_ONE",
  OPTIONS_CHOOSE_MULTIPLE: "OPTIONS_CHOOSE_MULTIPLE",
  FILE_ATTACHMENT: "FILE_ATTACHMENT",
  SECTION_TITLE: "SECTION_TITLE",
  TEXT_BLOCK: "TEXT_BLOCK",
  SIGNATURE_BLOCK: "SIGNATURE_BLOCK"
};

export const AnswerTypeList = [
  { value: AnswerType.TEXT, name: "Short answer" },
  { value: AnswerType.LONG_TEXT, name: "Long answer" },
  { value: AnswerType.NUMBER, name: "Number entry" },
  { value: AnswerType.DATE, name: "Date selection" },
  { value: AnswerType.OPTIONS_CHOOSE_ONE, name: "Options - Single-select" },
  {
    value: AnswerType.OPTIONS_CHOOSE_MULTIPLE,
    name: "Options - Multiple-select"
  },
  { value: AnswerType.FILE_ATTACHMENT, name: "File upload" },
  { value: AnswerType.SECTION_TITLE, name: "Section title" },
  { value: AnswerType.TEXT_BLOCK, name: "Text block" },
  { value: AnswerType.SIGNATURE_BLOCK, name: "Signature block" }
];

export const RegistrationAnswerType = {
  TEXT: "TEXT",
  LONG_TEXT: "LONG_TEXT",
  NUMBER: "NUMBER",
  DATE: "DATE",
  OPTIONS_CHOOSE_ONE: "OPTIONS_CHOOSE_ONE",
  OPTIONS_CHOOSE_MULTIPLE: "OPTIONS_CHOOSE_MULTIPLE",
  FILE_ATTACHMENT: "FILE_ATTACHMENT",
  WAIVER: "WAIVER",
  SECTION_TITLE: "SECTION_TITLE",
  TEXT_BLOCK: "TEXT_BLOCK",
  SIGNATURE_BLOCK: "SIGNATURE_BLOCK"
};

export const RegistrationAnswerTypeList = [
  { value: RegistrationAnswerType.TEXT, name: "Short answer" },
  { value: RegistrationAnswerType.LONG_TEXT, name: "Long answer" },
  { value: RegistrationAnswerType.NUMBER, name: "Number entry" },
  { value: RegistrationAnswerType.DATE, name: "Date selection" },
  {
    value: RegistrationAnswerType.OPTIONS_CHOOSE_ONE,
    name: "Options - Single-select"
  },
  {
    value: AnswerType.OPTIONS_CHOOSE_MULTIPLE,
    name: "Options - Multiple-select"
  },
  { value: RegistrationAnswerType.FILE_ATTACHMENT, name: "File upload" },
  { value: RegistrationAnswerType.WAIVER, name: "Waiver" },
  { value: RegistrationAnswerType.SECTION_TITLE, name: "Section title" },
  { value: RegistrationAnswerType.TEXT_BLOCK, name: "Text block" },
  { value: RegistrationAnswerType.SIGNATURE_BLOCK, name: "Signature block" }
];
